"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPlatformOrderPay = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var pay_1 = require("../../model/pay");
var service_1 = require("../../../library/base/service");
var ThirdPlatformOrderPay = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ThirdPlatformOrderPay, _super);
    function ThirdPlatformOrderPay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '第三方订单支付';
        _this.code = '101225';
        _this.desc = '第三方订单支付';
        _this.requestParams = new pay_1.ThirdPlatformOrderPayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ThirdPlatformOrderPay;
}(service_1.BaseService));
exports.ThirdPlatformOrderPay = ThirdPlatformOrderPay;
//# sourceMappingURL=thirdPlatformOrderPay.js.map